import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Mode, QuestionType } from '../../app.constant';
import { CommonService } from '../../service/common.service';

@Component({
  selector: 'app-b-none',
  templateUrl: './b-none.component.html',
  styleUrls: ['./b-none.component.css']
})
export class BNoneComponent implements OnInit {

  @Input() question: any;
  @Input() t_result_list: any[];
  @Input() mode: number;

  MODE: any = Mode;
  Q_TYPE:any = QuestionType;

  constructor(
    private commonService: CommonService
  ) { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/parts/b-none/b-none.component.ts